export default __webpack_public_path__ + "static/media/node.38d424a0.svg";